import { render, staticRenderFns } from "./PackagesComponent.vue?vue&type=template&id=4e4fc0d3&scoped=true&"
import script from "./PackagesComponent.vue?vue&type=script&lang=js&"
export * from "./PackagesComponent.vue?vue&type=script&lang=js&"
import style0 from "./PackagesComponent.vue?vue&type=style&index=0&id=4e4fc0d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4fc0d3",
  null
  
)

export default component.exports